module.exports = __webpack_public_path__ + "img/home-banner.4bd99b42.png";